<app-modal-container>
  <span class="modal-header-content">
    {{ 'label_confirm_property_type_change_title' | translate }}
  </span>

  <div class="modal-body-content d-flex flex-column">
    <div>
      {{ 'label_confirm_property_type_change_description' | translate }}
    </div>
    <div class="margin-top">
      {{ 'label_confirm_property_type_change_note' | translate }}
    </div>
  </div>

  <div class="modal-footer-content">
    <div class="d-flex justify-content-end">
      <button class="btn btn-outline-primary" (click)="close()">
        {{ 'label_close' | translate }}
      </button>
      <button class="btn btn-primary margin-left" (click)="onConfirm()">
        {{ 'label_confirm' | translate }}
      </button>
    </div>
  </div>
</app-modal-container>
